import { IGlobalState } from '../../../Root/store/appReducer'

//export const userActivitySelector = (state: IGlobalState) => state.settings.activity
//export const userBadgeSelector = (state: IGlobalState) => state.settings.badges
export const companyDivisionsSelector = (state: IGlobalState) => state.settings.divisions
export const companyCountriesSelector = (state: IGlobalState) => state.settings.countries
export const userDtoSelector = (state: IGlobalState) => state.auth.userDto
export const userCompaniesSelector = (state: IGlobalState) => state.auth.userCompanies
export const managedCompaniesSelector = (state: IGlobalState) => state.auth.managedCompanies
